import { Component, Input, OnInit } from '@angular/core';
import { POSTimeClock } from '../../model/tx.timer-clock.model';
import { PosTimeService } from '../../services/pos.time.service';


@Component({
  selector: 'app-header-time-clock',
  templateUrl: './header-time-clock.component.html',
  styleUrls: ['./header-time-clock.component.scss']
})
export class HeaderTimeClockComponent implements OnInit {
	/**
	 * variable used to store TxTime Instance.
	 */
	posTimer!: POSTimeClock;
	/**
	 * Input member variable
	 * Date Object to get time.
	 */
	@Input()
  date!: Date;
	/**
	 * Input member variable
	 * show time according to Given Time Zone
	 */
	@Input() timeZone = 'IST';
	/**
	 * Input member variable
	 * if true then show 24 hr clock else show 12 hr clock
	 */
	@Input()
  isMilitaryTime = true;
	/**
	 * Creates an instance of tx time clock component.
	 * @param txTimerService txTimerService Instance passed to TxTimer
	 */
	constructor(private posTimerService: PosTimeService) {}

	/**
	 * Implement onInit Event Handler
	 * create HwTimer Instance to show time on UI.
	 */
	ngOnInit(): void {
		if (this.date === undefined) {
			this.date = this.posTimerService.getCurrentDate();
		}
		this.posTimer = new POSTimeClock(this.posTimerService);
		this.posTimer.init(this.isMilitaryTime, true);
	}

	}
